angular.module('cpm').directive("draggableCanvasLayoutItem", function() {
    return {
        restrict: "A",
        scope: {
            canvas: "=draggableCanvasLayoutItem"
        },
        link: function($scope, $el, attr) {

            $el.data("reflow-asset", $scope.canvas);

            $el.draggable({
                helper: "clone",
                cursor: '-webkit-grabbing',
                appendTo: "body",
                containment: "body",
                distance: 5,
                delay: 250
            });

        }
    };
});
